// // // // // // // // // // import { createSlice } from '@reduxjs/toolkit';

// // // // // // // // // // const initialState = {
// // // // // // // // // //   token: localStorage.getItem('auth_token') || null,
// // // // // // // // // //   userRole: localStorage.getItem('user_role') || null,
// // // // // // // // // //   isAuthenticated: false,
// // // // // // // // // // };

// // // // // // // // // // const authSlice = createSlice({
// // // // // // // // // //   name: 'auth',
// // // // // // // // // //   initialState,
// // // // // // // // // //   reducers: {
// // // // // // // // // //     login: (state, action) => {
// // // // // // // // // //       state.token = action.payload.token;
// // // // // // // // // //       state.userRole = action.payload.role;
// // // // // // // // // //       state.isAuthenticated = true;
// // // // // // // // // //       localStorage.setItem('auth_token', action.payload.token);
// // // // // // // // // //       localStorage.setItem('user_role', action.payload.role);
// // // // // // // // // //     },
// // // // // // // // // //     logout: (state) => {
// // // // // // // // // //       state.token = null;
// // // // // // // // // //       state.userRole = null;
// // // // // // // // // //       state.isAuthenticated = false;
// // // // // // // // // //       localStorage.removeItem('auth_token');
// // // // // // // // // //       localStorage.removeItem('user_role');
// // // // // // // // // //     },
// // // // // // // // // //   },
// // // // // // // // // // });

// // // // // // // // // // export const { login, logout } = authSlice.actions;

// // // // // // // // // // export default authSlice.reducer;



// // // // // // // // // import { createSlice } from '@reduxjs/toolkit';

// // // // // // // // // const initialState = {
// // // // // // // // //   role: 'admin',  // Default role
// // // // // // // // //   permissions: [
// // // // // // // // //     'view_dashboard',
// // // // // // // // //     'view_registration_approval',
// // // // // // // // //     'view_user_management',
// // // // // // // // //     'view_reports',
// // // // // // // // //   ],  // Default permissions
// // // // // // // // // };

// // // // // // // // // const authSlice = createSlice({
// // // // // // // // //   name: 'auth',
// // // // // // // // //   initialState,
// // // // // // // // //   reducers: {
// // // // // // // // //     setUserRoleAndPermissions: (state, action) => {
// // // // // // // // //       state.role = action.payload.role;
// // // // // // // // //       state.permissions = action.payload.permissions;
// // // // // // // // //     },
// // // // // // // // //   },
// // // // // // // // // });

// // // // // // // // // export const { setUserRoleAndPermissions } = authSlice.actions;
// // // // // // // // // export default authSlice.reducer;


// // // // // // // // import { createSlice } from '@reduxjs/toolkit';

// // // // // // // // const initialState = {
// // // // // // // //   role: '',
// // // // // // // //   permissions: [],
// // // // // // // //   isLoggedIn: false, // Track if the user is logged in
// // // // // // // // };

// // // // // // // // const authSlice = createSlice({
// // // // // // // //   name: 'auth',
// // // // // // // //   initialState,
// // // // // // // //   reducers: {
// // // // // // // //     loginUser: (state, action) => {
// // // // // // // //       const { role, permissions } = action.payload;
// // // // // // // //       state.role = role;
// // // // // // // //       state.permissions = permissions;
// // // // // // // //       state.isLoggedIn = true;
// // // // // // // //     },
// // // // // // // //     logoutUser: (state) => {
// // // // // // // //       state.role = '';
// // // // // // // //       state.permissions = [];
// // // // // // // //       state.isLoggedIn = false;
// // // // // // // //     },
// // // // // // // //   },
// // // // // // // // });

// // // // // // // // export const { loginUser, logoutUser } = authSlice.actions;
// // // // // // // // export default authSlice.reducer;

// // // // // // // // authSlice.js



// // // // // // // import { createSlice } from '@reduxjs/toolkit';

// // // // // // // const initialState = {
// // // // // // //   role: '',
// // // // // // //   permissions: [],
// // // // // // //   isLoggedIn: false, // Track if the user is logged in
// // // // // // // };

// // // // // // // const authSlice = createSlice({
// // // // // // //   name: 'auth',
// // // // // // //   initialState,
// // // // // // //   reducers: {
// // // // // // //     loginUser: (state, action) => {
// // // // // // //       const { role, permissions } = action.payload;
// // // // // // //       state.role = role;
// // // // // // //       state.permissions = permissions;
// // // // // // //       state.isLoggedIn = true;
// // // // // // //     },
// // // // // // //     logoutUser: (state) => {
// // // // // // //       state.role = '';
// // // // // // //       state.permissions = [];
// // // // // // //       state.isLoggedIn = false;
// // // // // // //     },
// // // // // // //   },
// // // // // // // });

// // // // // // // export const { loginUser, logoutUser } = authSlice.actions;  // Ensure this line is correct
// // // // // // // export default authSlice.reducer;


// // // // // // import { createSlice } from '@reduxjs/toolkit';

// // // // // // const initialState = {
// // // // // //   role: '',
// // // // // //   permissions: [],
// // // // // //   isLoggedIn: false, // Track if the user is logged in
// // // // // // };

// // // // // // const authSlice = createSlice({
// // // // // //   name: 'auth',
// // // // // //   initialState,
// // // // // //   reducers: {   
// // // // // //     loginUser: (state, action) => {
// // // // // //       const { role, permissions } = action.payload;
// // // // // //       state.role = role;
// // // // // //       state.permissions = permissions;
// // // // // //       state.isLoggedIn = true;
      
// // // // // //     },
// // // // // //     logoutUser: (state) => {
// // // // // //       state.role = '';
// // // // // //       state.permissions = [];
// // // // // //       state.isLoggedIn = false;
// // // // // //     },
// // // // // //   },
// // // // // // });

// // // // // // export const { loginUser, logoutUser } = authSlice.actions;
// // // // // // export default authSlice.reducer;


// // // // // import { createSlice } from "@reduxjs/toolkit";

// // // // // // Load state from localStorage
// // // // // const savedAuthState = JSON.parse(localStorage.getItem("authState")) || {
// // // // //   role: "",
// // // // //   permissions: [],
// // // // //   isLoggedIn: false,
// // // // // };

// // // // // const authSlice = createSlice({
// // // // //   name: "auth",
// // // // //   initialState: savedAuthState,
// // // // //   reducers: {
// // // // //     loginUser: (state, action) => {
// // // // //       const { role, permissions } = action.payload;
// // // // //       state.role = role;
// // // // //       state.permissions = permissions;
// // // // //       state.isLoggedIn = true;

// // // // //       // Save to localStorage
// // // // //       localStorage.setItem("authState", JSON.stringify(state));
// // // // //     },
// // // // //     logoutUser: (state) => {
// // // // //       state.role = "";
// // // // //       state.permissions = [];
// // // // //       state.isLoggedIn = false;

// // // // //       // Clear from localStorage
// // // // //       localStorage.removeItem("authState");
// // // // //     },
// // // // //   },
// // // // // });

// // // // // export const { loginUser, logoutUser } = authSlice.actions;
// // // // // export default authSlice.reducer;



// // // // import { createSlice } from "@reduxjs/toolkit";

// // // // // Load state from sessionStorage
// // // // const savedAuthState = JSON.parse(sessionStorage.getItem("authState")) || {
// // // //   role: "",
// // // //   permissions: [],
// // // //   isLoggedIn: false,
// // // // };

// // // // const authSlice = createSlice({
// // // //   name: "auth",
// // // //   initialState: savedAuthState,
// // // //   reducers: {
// // // //     loginUser: (state, action) => {
// // // //       const { role, permissions } = action.payload;
// // // //       state.role = role;
// // // //       state.permissions = permissions;
// // // //       state.isLoggedIn = true;

// // // //       // Save to sessionStorage
// // // //       sessionStorage.setItem("authState", JSON.stringify(state));
// // // //     },
// // // //     logoutUser: (state) => {
// // // //       state.role = "";
// // // //       state.permissions = [];
// // // //       state.isLoggedIn = false;

// // // //       // Clear from sessionStorage
// // // //       sessionStorage.removeItem("authState");
// // // //     },
// // // //   },
// // // // });

// // // // export const { loginUser, logoutUser } = authSlice.actions;
// // // // export default authSlice.reducer;




// // // import { createSlice } from "@reduxjs/toolkit";

// // // // Load state from sessionStorage
// // // const savedAuthState = JSON.parse(sessionStorage.getItem("authState")) || {
// // //   role: "superadmin",
// // //   permissions: {
// // //     Dashboard: { Dashboard: { add: false, edit: false, delete: true, view: true } },
// // //     OperatorRegistration: {
// // //       "All User List": { add: true, edit: false, delete: true, view: true },
// // //       "Purchaser List": { add: true, edit: true, delete: true, view: true },
// // //       "Referrer List": { add: true, edit: true, delete: true, view: true },
// // //       "Financial Consultant List": { add: true, edit: true, delete: true, view: true }
// // //     },
// // //     SchemeManagement: {
// // //       "Gold Stake Schemes": { add: true, edit: true, delete: true, view: true },
// // //       "Referral Schemes": { add: true, edit: true, delete: true, view: true }
// // //     },
// // //     ContentManagement: {
// // //       Home: { add: true, edit: true, delete: true, view: true },
// // //       "Stake Now": { add: true, edit: true, delete: true, view: true },
// // //       "About Us": { add: true, edit: true, delete: true, view: true },
// // //       Blog: { add: true, edit: true, delete: true, view: true },
// // //       "Contact Us": { add: false, edit: false, delete: false, view: false }
// // //     }
// // //   },
// // //   isLoggedIn: false,
// // // };

// // // const authSlice = createSlice({
// // //   name: "auth",
// // //   initialState: savedAuthState,
// // //   reducers: {
// // //     loginUser: (state, action) => {
// // //       const { role, permissions } = action.payload;
// // //       state.role = role;
// // //       state.permissions = permissions;
// // //       state.isLoggedIn = true;
      
// // //       // Save to sessionStorage
// // //       sessionStorage.setItem("authState", JSON.stringify(state));
// // //     },
// // //     logoutUser: (state) => {
// // //       state.role = "";
// // //       state.permissions = {};
// // //       state.isLoggedIn = false;

// // //       // Clear from sessionStorage
// // //       sessionStorage.removeItem("authState");
// // //     },
// // //   },
// // // });

// // // export const { loginUser, logoutUser } = authSlice.actions;
// // // export default authSlice.reducer;



// // import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// // import axios from "axios";

// // // Async action to fetch user details
// // export const loginUser = createAsyncThunk("auth/loginUser", async (credentials, { rejectWithValue }) => {
// //     try {
// //         const response = await axios.post("/api/login", credentials);
// //         return response.data; // Expecting { token, roleName, permissions }
// //     } catch (error) {
// //         return rejectWithValue(error.response.data);
// //     }
// // });

// // const authSlice = createSlice({
// //     name: "auth",
// //     initialState: {
// //         user: null,
// //         role: null,
// //         token: null,
// //         permissions: {},
// //         isAuthenticated: false,
// //         loading: false,
// //         error: null,
// //     },
// //     reducers: {
// //         logout: (state) => {
// //             state.user = null;
// //             state.role = null;
// //             state.token = null;
// //             state.permissions = {};
// //             state.isAuthenticated = false;
// //             localStorage.removeItem("token");
// //         },
// //     },
// //     extraReducers: (builder) => {
// //         builder
// //             .addCase(loginUser.fulfilled, (state, action) => {
// //                 state.user = action.payload.user;
// //                 state.role = action.payload.roleName;
// //                 state.token = action.payload.token;
// //                 state.permissions = action.payload.permissions;
// //                 state.isAuthenticated = true;
// //                 localStorage.setItem("token", action.payload.token);
// //             })
// //             .addCase(loginUser.rejected, (state, action) => {
// //                 state.loading = false;
// //                 state.error = action.payload;
// //             });
// //     },
// // });

// // export const { logout } = authSlice.actions;
// // export default authSlice.reducer;





// import { createSlice } from "@reduxjs/toolkit";

// // Load state from sessionStorage
// const savedAuthState = JSON.parse(sessionStorage.getItem("authState")) || {
//   role: "",
//   permissions: [],
//   isLoggedIn: false,
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState: savedAuthState,
//   reducers: {
//     loginUser: (state, action) => {
//       const { role, permissions } = action.payload;
//       state.role = role;
//       state.permissions = permissions;
//       state.isLoggedIn = true;

//       // Save to sessionStorage
//       sessionStorage.setItem("authState", JSON.stringify(state));
//     },
//     logoutUser: (state) => {
//       state.role = "";
//       state.permissions = [];
//       state.isLoggedIn = false;

//       // Clear from sessionStorage
//       sessionStorage.removeItem("authState");
//     },
//   },
// });

// export const { loginUser, logoutUser } = authSlice.actions;
// export default authSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        user: null,
        role: null,
        token: sessionStorage.getItem("token") || null,
        permissions: {},
        isAuthenticated: !!sessionStorage.getItem("token"),
        error: null,
    },
    reducers: {
        loginSuccess: (state, action) => {
            state.user = action.payload.user;
            state.role = action.payload.role;
            state.token = action.payload.token;
            state.permissions = action.payload.permissions;
            state.isAuthenticated = true;
            console.log("Permissions:", state.permissions);

              // Store in localStorage
              sessionStorage.setItem("user", JSON.stringify(action.payload.user));
              sessionStorage.setItem("role", action.payload.role);
              sessionStorage.setItem("token", action.payload.token);
              sessionStorage.setItem("permissions", JSON.stringify(action.payload.permissions));
   
        },
        logout: (state) => {
            state.user = null;
            state.role = null;
            state.token = null;
            state.permissions = {};
            state.isAuthenticated = false;
            // localStorage.removeItem("token");

            // Clear localStorage
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("role");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("permissions");
        },
    },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;